import { LoaderFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import { DiscountCodeData } from "@/routes/lecturer/routes/discountCode/main/types/discountCodeData.ts";

export async function discountCodeEditLoader({
  params,
}: LoaderFunctionArgs): Promise<DiscountCodeData> {
  try {
    if (!params.discountCodeId) {
      return {} as DiscountCodeData;
    }

    const response = await apiEndpoints.getLecturerDiscountCodeById(
      params.discountCodeId
    );
    return response.data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : "Unknown error");
  }
}
